import { api } from "..";

const endpoint = "/api/purchase-orders";

// PURCHASE ORDERS
export const getPurchaseOrderList = (queryParams) => {
  return api.get(`${endpoint}`, { params: queryParams });
};

export const getPurchaseOrderDetail = (id) => {
  return api.get(`${endpoint}/${id}`);
};

export const addPurchaseOrder = (data) => {
  return api.post(`${endpoint}`, data);
};

export const updatePurchaseOrder = (id, data) => {
  return api.put(`${endpoint}/${id}`, data);
};

export const updatePurchaseOrderHeader = (id, data) => {
  return api.put(`${endpoint}/header/${id}`, data);
};

export const patchPurchaseOrder = (id, data) => {
  return api.patch(`${endpoint}/${id}`, data);
};

export const deletePurchaseOrder = (id) => {
  return api.delete(`${endpoint}/${id}`);
};

export const approvePurchaseOrder = (id) => {
  return api.post(`${endpoint}/${id}/approve`);
};

export const cancelPurchaseOrder = (id) => {
  return api.post(`${endpoint}/${id}/cancel`);
};

// PO ITEMS
export const getPOItemList = (queryParams) => {
  return api.get(`${endpoint}/items`, { params: queryParams });
};

export const getPOItemById = (id) => {
  return api.get(`${endpoint}/items/${id}`);
};

export const addPOItem = (data) => {
  return api.post(`${endpoint}/items`, data);
};

export const updatePOItem = (id, data) => {
  return api.put(`${endpoint}/items/${id}`, data);
};

export const deletePOItem = (id) => {
  return api.delete(`${endpoint}/items/${id}`);
};

// EXPORT TO PDF
export const exportPO = (id, showPrices) => {
  return api.get(`${endpoint}/${id}/export?showPrices=${showPrices}`, {
    responseType: "blob",
    headers: { Accept: "*/*" },
  });
};
